import { scroller } from 'react-scroll'

// export const filterObject = (arr: [], searchKey: string) => {
//   return arr.filter((obj) => Object.keys(obj).some((key) => obj[key].toLowerCase().includes(searchKey)))
// }

export const filterObject = (arr: [], searchKey: string) => {
  return arr.filter((el) =>
    Object.values(el[0]).some((k: string) => {
      return k.toLowerCase().includes(searchKey)
    })
  )
}

export const filterObjectByTitle = (arr: [], searchKey: string) => {
  return arr.filter((obj) => obj.title.toLowerCase().includes(searchKey))
}

export const scrollToSection = (target: string, durationVal = 800, delayVal = 0, offsetVal = 0) =>
  scroller.scrollTo(target, {
    duration: durationVal,
    delay: delayVal,
    smooth: true,
    offset: offsetVal
  })
